/* eslint-disable */
import * as yup from 'yup';

export const chargeOnlienYupSchema = yup.object({
    name: yup.string().required('입금자명을 입력해주세요.'),
    phoneNumber: yup.string()
});
